import React from 'react';
import { CheckSquare, Calendar, Clock, Users, MessageSquare, FileText, ChevronRight, PaperclipIcon, Send } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TaskDetail() {
  const task = {
    id: 1,
    title: 'مراجعة التقارير المالية للربع الثالث',
    description: 'مراجعة وتحليل التقارير المالية للربع الثالث، وتحديد أي تناقضات، وإعداد ملخص لاجتماع اللجنة.',
    committee: 'لجنة المالية',
    assignedTo: 'محمد الهاشمي',
    createdBy: 'أحمد علي',
    createdDate: '2023-08-30',
    deadline: '2023-09-15',
    status: 'completed',
    priority: 'high',
    progress: 100,
    attachments: [{
      id: 1,
      name: 'التقرير_المالي_الربع_الثالث.xlsx',
      size: '2.4 ميجابايت',
      type: 'XLSX'
    }, {
      id: 2,
      name: 'إرشادات_التحليل.pdf',
      size: '1.8 ميجابايت',
      type: 'PDF'
    }],
    comments: [{
      id: 1,
      user: 'أحمد علي',
      avatar: 'أ',
      date: '2023-09-01',
      time: '10:30 صباحاً',
      content: 'يرجى التأكد من فحص قسم نفقات التسويق بعناية.'
    }, {
      id: 2,
      user: 'محمد الهاشمي',
      avatar: 'م',
      date: '2023-09-02',
      time: '02:15 مساءً',
      content: 'لاحظت بعض التناقضات في توقعات الإيرادات. سأتناولها في مراجعتي.'
    }, {
      id: 3,
      user: 'عائشة المنصوري',
      avatar: 'ع',
      date: '2023-09-10',
      time: '11:45 صباحاً',
      content: 'التقرير يبدو جيداً بشكل عام. لقد أضفت بعض التعليقات في جدول البيانات المرفق.'
    }]
  };
  const getStatusClass = (status: string) => {
    switch (status) {
      case 'completed':
        return 'bg-green-100 text-green-800';
      case 'pending':
        return 'bg-orange-100 text-orange-800';
      case 'delayed':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  const getPriorityClass = (priority: string) => {
    switch (priority) {
      case 'high':
        return 'bg-red-100 text-red-800';
      case 'medium':
        return 'bg-orange-100 text-orange-800';
      case 'low':
        return 'bg-blue-100 text-blue-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  const getFileIcon = (type: string) => {
    switch (type) {
      case 'PDF':
        return <FileText size={16} className="text-red-500" data-id="element-2069" />;
      case 'DOCX':
        return <FileText size={16} className="text-blue-500" data-id="element-2070" />;
      case 'XLSX':
        return <FileText size={16} className="text-green-500" data-id="element-2071" />;
      case 'PPTX':
        return <FileText size={16} className="text-orange-500" data-id="element-2072" />;
      default:
        return <FileText size={16} className="text-gray-500" data-id="element-2073" />;
    }
  };
  return <div dir="rtl" data-id="element-2074">
      <div className="flex items-center mb-6" data-id="element-2075">
        <Link to="/tasks" className="flex items-center text-gray-600 hover:text-gray-900 ml-4" data-id="element-2076">
          <ChevronRight size={20} className="ml-1" data-id="element-2077" />
          العودة
        </Link>
        <h1 className="text-2xl font-bold" data-id="element-2078">{task.title}</h1>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-2079">
        {/* Task Details */}
        <div className="lg:col-span-2" data-id="element-2080">
          <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-2081">
            <div className="flex flex-wrap gap-3 mb-4" data-id="element-2082">
              <span className={`px-3 py-1 inline-flex items-center text-xs font-medium rounded-full ${getStatusClass(task.status)}`} data-id="element-2083">
                <CheckSquare size={14} className="ml-1" data-id="element-2084" />
                {task.status === 'completed' ? 'مكتملة' : task.status === 'pending' ? 'معلقة' : 'متأخرة'}
              </span>
              <span className={`px-3 py-1 inline-flex items-center text-xs font-medium rounded-full ${getPriorityClass(task.priority)}`} data-id="element-2085">
                الأولوية:{' '}
                {task.priority === 'high' ? 'عالية' : task.priority === 'medium' ? 'متوسطة' : 'منخفضة'}
              </span>
            </div>
            <div className="mb-6" data-id="element-2086">
              <h2 className="text-lg font-semibold mb-2" data-id="element-2087">الوصف</h2>
              <p className="text-gray-700" data-id="element-2088">{task.description}</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-2089">
              <div data-id="element-2090">
                <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-2091">
                  اللجنة
                </h3>
                <div className="flex items-center" data-id="element-2092">
                  <Users size={16} className="text-gray-500 ml-2" data-id="element-2093" />
                  <span data-id="element-2094">{task.committee}</span>
                </div>
              </div>
              <div data-id="element-2095">
                <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-2096">
                  مسندة إلى
                </h3>
                <div className="flex items-center" data-id="element-2097">
                  <div className="h-6 w-6 bg-gray-700 rounded-full flex items-center justify-center text-white text-xs font-medium ml-2" data-id="element-2098">
                    {task.assignedTo.charAt(0)}
                  </div>
                  <span data-id="element-2099">{task.assignedTo}</span>
                </div>
              </div>
              <div data-id="element-2100">
                <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-2101">
                  أنشئت بواسطة
                </h3>
                <div className="flex items-center" data-id="element-2102">
                  <div className="h-6 w-6 bg-gray-700 rounded-full flex items-center justify-center text-white text-xs font-medium ml-2" data-id="element-2103">
                    {task.createdBy.charAt(0)}
                  </div>
                  <span data-id="element-2104">{task.createdBy}</span>
                </div>
              </div>
              <div data-id="element-2105">
                <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-2106">
                  تاريخ الإنشاء
                </h3>
                <div className="flex items-center" data-id="element-2107">
                  <Calendar size={16} className="text-gray-500 ml-2" data-id="element-2108" />
                  <span data-id="element-2109">{task.createdDate}</span>
                </div>
              </div>
              <div data-id="element-2110">
                <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-2111">
                  تاريخ الاستحقاق
                </h3>
                <div className="flex items-center" data-id="element-2112">
                  <Clock size={16} className="text-gray-500 ml-2" data-id="element-2113" />
                  <span data-id="element-2114">{task.deadline}</span>
                </div>
              </div>
              <div data-id="element-2115">
                <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-2116">
                  نسبة الإنجاز
                </h3>
                <div className="w-full bg-gray-200 rounded-full h-2.5 mb-1" data-id="element-2117">
                  <div className="h-2.5 rounded-full bg-green-500" style={{
                  width: `${task.progress}%`
                }} data-id="element-2118"></div>
                </div>
                <span className="text-xs text-gray-500" data-id="element-2119">{task.progress}%</span>
              </div>
            </div>
            <div className="mb-6" data-id="element-2120">
              <h2 className="text-lg font-semibold mb-3" data-id="element-2121">المرفقات</h2>
              <div className="space-y-2" data-id="element-2122">
                {task.attachments.map(attachment => <div key={attachment.id} className="flex items-center justify-between p-3 border border-gray-200 rounded-lg" data-id="element-2123">
                    <div className="flex items-center" data-id="element-2124">
                      {getFileIcon(attachment.type)}
                      <span className="mr-2 font-medium" data-id="element-2125">
                        {attachment.name}
                      </span>
                      <span className="mr-2 text-xs text-gray-500" data-id="element-2126">
                        {attachment.size}
                      </span>
                    </div>
                    <div className="flex space-x-2" data-id="element-2127">
                      <button className="p-1 text-blue-500 hover:text-blue-700 ml-2" data-id="element-2128">
                        <FileText size={16} data-id="element-2129" />
                      </button>
                      <button className="p-1 text-green-500 hover:text-green-700" data-id="element-2130">
                        <PaperclipIcon size={16} data-id="element-2131" />
                      </button>
                    </div>
                  </div>)}
              </div>
            </div>
            <div data-id="element-2132">
              <h2 className="text-lg font-semibold mb-3" data-id="element-2133">التعليقات</h2>
              <div className="space-y-4 mb-4" data-id="element-2134">
                {task.comments.map(comment => <div key={comment.id} className="flex" data-id="element-2135">
                    <div className="h-8 w-8 bg-gray-700 rounded-full flex items-center justify-center text-white font-medium ml-3 flex-shrink-0" data-id="element-2136">
                      {comment.avatar}
                    </div>
                    <div className="bg-gray-100 p-3 rounded-lg flex-1" data-id="element-2137">
                      <div className="flex justify-between items-center mb-1" data-id="element-2138">
                        <span className="font-medium" data-id="element-2139">{comment.user}</span>
                        <span className="text-xs text-gray-500" data-id="element-2140">
                          {comment.date} الساعة {comment.time}
                        </span>
                      </div>
                      <p className="text-sm" data-id="element-2141">{comment.content}</p>
                    </div>
                  </div>)}
              </div>
              <div className="flex items-center mt-4" data-id="element-2142">
                <div className="h-8 w-8 bg-gray-700 rounded-full flex items-center justify-center text-white font-medium ml-3" data-id="element-2143">
                  أ
                </div>
                <div className="flex-1 relative" data-id="element-2144">
                  <input type="text" placeholder="أضف تعليقاً..." className="w-full border border-gray-200 rounded-md px-4 py-2 pl-10 focus:outline-none focus:ring-1 focus:ring-orange-500" data-id="element-2145" />
                  <button className="absolute left-2 top-1/2 transform -translate-y-1/2 text-orange-500" data-id="element-2146">
                    <Send size={18} data-id="element-2147" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Sidebar */}
        <div data-id="element-2148">
          <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-2149">
            <h2 className="text-lg font-semibold mb-4" data-id="element-2150">الإجراءات</h2>
            <div className="space-y-3" data-id="element-2151">
              <button className="w-full flex items-center justify-center p-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-2152">
                <CheckSquare size={18} className="ml-2" data-id="element-2153" />
                وضع علامة مكتملة
              </button>
              <button className="w-full flex items-center justify-center p-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors" data-id="element-2154">
                <Users size={18} className="ml-2" data-id="element-2155" />
                إعادة تعيين المهمة
              </button>
              <button className="w-full flex items-center justify-center p-2 bg-purple-500 text-white rounded-md hover:bg-purple-600 transition-colors" data-id="element-2156">
                <PaperclipIcon size={18} className="ml-2" data-id="element-2157" />
                إضافة مرفق
              </button>
              <button className="w-full flex items-center justify-center p-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors" data-id="element-2158">
                <MessageSquare size={18} className="ml-2" data-id="element-2159" />
                إرسال تذكير
              </button>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-2160">
            <h2 className="text-lg font-semibold mb-4" data-id="element-2161">المهام ذات الصلة</h2>
            <div className="space-y-3" data-id="element-2162">
              <div className="border border-gray-200 rounded-lg p-3" data-id="element-2163">
                <h3 className="font-medium mb-2" data-id="element-2164">
                  إعداد مقترح الميزانية لعام 2024
                </h3>
                <div className="flex justify-between items-center" data-id="element-2165">
                  <div className="flex items-center text-sm text-gray-500" data-id="element-2166">
                    <Clock size={14} className="ml-1" data-id="element-2167" />
                    تاريخ الاستحقاق: 2023-10-10
                  </div>
                  <span className="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-orange-100 text-orange-800" data-id="element-2168">
                    معلقة
                  </span>
                </div>
              </div>
              <div className="border border-gray-200 rounded-lg p-3" data-id="element-2169">
                <h3 className="font-medium mb-2" data-id="element-2170">
                  تدقيق تقارير النفقات من الربع الثاني
                </h3>
                <div className="flex justify-between items-center" data-id="element-2171">
                  <div className="flex items-center text-sm text-gray-500" data-id="element-2172">
                    <Clock size={14} className="ml-1" data-id="element-2173" />
                    تاريخ الاستحقاق: 2023-09-30
                  </div>
                  <span className="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-orange-100 text-orange-800" data-id="element-2174">
                    معلقة
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}